var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumWithCircle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_3869)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.33398,
    y: 3.3335,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "#7F8283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74626 13.3335V12.4414L9.78971 10.4243C10.0885 10.1372 10.32 9.90137 10.484 9.7168C10.6481 9.5293 10.7624 9.3667 10.8268 9.229C10.8913 9.08838 10.9235 8.94336 10.9235 8.79395V8.78076C10.9235 8.59912 10.884 8.43945 10.8049 8.30176C10.7287 8.16406 10.6174 8.05713 10.4709 7.98096C10.3244 7.90186 10.1501 7.8623 9.94792 7.8623C9.74284 7.8623 9.5612 7.90625 9.40299 7.99414C9.24479 8.0791 9.12174 8.19775 9.03385 8.3501C8.94596 8.49951 8.90202 8.67529 8.90202 8.87744V8.89941H7.67594L7.67155 8.87744C7.67155 8.47314 7.76969 8.11719 7.96598 7.80957C8.1652 7.50195 8.43913 7.26172 8.78776 7.08887C9.13932 6.91602 9.54655 6.82959 10.0094 6.82959C10.446 6.82959 10.8298 6.90723 11.1608 7.0625C11.4948 7.21777 11.7555 7.43311 11.943 7.7085C12.1335 7.98389 12.2287 8.30469 12.2287 8.6709V8.68408C12.2287 8.92432 12.1818 9.16016 12.0881 9.3916C11.9943 9.62012 11.8361 9.86768 11.6134 10.1343C11.3908 10.4009 11.0861 10.7129 10.6994 11.0703L9.17008 12.4985L9.52604 11.9185V12.4985L9.17008 12.2656H12.321V13.3335H7.74626Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_3869"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.33398,
    y: 3.3335,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumWithCircle2);
export default __webpack_public_path__ + "static/media/NumWithCircle_2.9d4f1a481d15f42bc315ab8de9a62921.svg";
export { ForwardRef as ReactComponent };